import { render } from "./bidangPerkebunan.vue?vue&type=template&id=3693f1a8"
import script from "./bidangPerkebunan.vue?vue&type=script&lang=js"
export * from "./bidangPerkebunan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__